import type { JwtPayload } from "../types";

/**
 * Decode a JWT token and extract the payload.
 * Does NOT verify the signature — that's the backend's job.
 * This is purely for reading claims client-side.
 */
export function parseJwt(token: string): JwtPayload {
    const parts = token.split(".");
    if (parts.length !== 3) {
        throw new Error("Invalid JWT format");
    }

    // Base64url → Base64 → decode
    const base64 = parts[1]
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    const json = decodeURIComponent(
        atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
    );

    return JSON.parse(json) as JwtPayload;
}

/** Check whether a JWT payload has expired (with optional buffer in seconds) */
export function isTokenExpired(payload: JwtPayload, bufferSeconds: number = 30): boolean {
    const nowSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= nowSeconds + bufferSeconds;
}